import classNames from "classnames";
export default function ParaText({
  children,
  classes = "",
  variant = "default",
}) {
  const defaultClasses = "text-lg text-gray-700 mb-4";
  const variantClasses = {
    default: "",
    sign: "font-semibold italic text-right",
  };

  const paraClasses = variantClasses[variant] || variantClasses.default;
  return (
    <p className={classNames(defaultClasses, paraClasses, classes)}>
      {children}
    </p>
  );
}
